import client from '../httpClient';

const webResUpdateAfterMargedCustomerApi = (params) => {
  return client.put('/responses/customer-to-customer', JSON.stringify(params), { isShowMessage: true });
};

export default webResUpdateAfterMargedCustomerApi;
